
import { record_type, option_type, int32_type, bool_type, union_type, string_type, class_type } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Reflection.js";
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Types.js";
import { some, defaultArg, value as value_13 } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Option.js";
import { InputMsg } from "../../Domain/Types.jsx";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Seq.js";
import { createElement, useRef, memo } from "react";
import React from "react";
import { useHaptic } from "use-haptic";
import { append as append_1, ofArray, choose, mapFold } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/List.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/String.js";
import { Button } from "@/components/ui/button";
import { equals, Exception } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Util.js";

export class ButtonIcon {
    constructor() {
    }
}

export function ButtonIcon_$reflection() {
    return class_type("MatheApp.UI.Components.OnScreenKeyboard.ButtonIcon", undefined, ButtonIcon);
}

export function ButtonIcon_get_check() {
    return "fa fa-check";
}

export function ButtonIcon_get_clear() {
    return "fa fa-backspace";
}

export class ButtonLabel extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Text", "Icon", "IconWithText"];
    }
}

export function ButtonLabel_$reflection() {
    return union_type("MatheApp.UI.Components.OnScreenKeyboard.ButtonLabel", [], ButtonLabel, () => [[["Item", string_type]], [["Item", string_type]], [["Item1", string_type], ["Item2", string_type]]]);
}

export class Key$1 extends Record {
    constructor(Label, Variant, IsWide, IsLarge, Column, IsEnabled, Msg, LongPressMsg) {
        super();
        this.Label = Label;
        this.Variant = Variant;
        this.IsWide = IsWide;
        this.IsLarge = IsLarge;
        this.Column = Column;
        this.IsEnabled = IsEnabled;
        this.Msg = Msg;
        this.LongPressMsg = LongPressMsg;
    }
}

export function Key$1_$reflection(gen0) {
    return record_type("MatheApp.UI.Components.OnScreenKeyboard.Key`1", [gen0], Key$1, () => [["Label", ButtonLabel_$reflection()], ["Variant", string_type], ["IsWide", bool_type], ["IsLarge", bool_type], ["Column", option_type(int32_type)], ["IsEnabled", bool_type], ["Msg", gen0], ["LongPressMsg", option_type(gen0)]]);
}

export class Key {
    constructor() {
    }
}

export function Key_$reflection() {
    return class_type("MatheApp.UI.Components.OnScreenKeyboard.Key", undefined, Key);
}

export function Key_Create_Z39EE07B2(text, msg, longPress, icon, isWide, column, isEnabled, variant, isLarge) {
    const Label = (icon != null) ? (new ButtonLabel(2, [value_13(icon), text])) : (new ButtonLabel(0, [text]));
    const Variant = defaultArg(variant, "secondary");
    const IsLarge = defaultArg(isLarge, false);
    return new Key$1(Label, Variant, defaultArg(isWide, false), IsLarge, column, defaultArg(isEnabled, true), msg, longPress);
}

export function Key_disabled_Z234A7F09(key) {
    return new Key$1(key.Label, key.Variant, key.IsWide, key.IsLarge, key.Column, false, key.Msg, key.LongPressMsg);
}

export function Key_withEnabled(isEnabled, key) {
    return new Key$1(key.Label, key.Variant, key.IsWide, key.IsLarge, key.Column, isEnabled, key.Msg, key.LongPressMsg);
}

export function Key_withLongPress(msg, key) {
    return new Key$1(key.Label, key.Variant, key.IsWide, key.IsLarge, key.Column, key.IsEnabled, key.Msg, some(msg));
}

export function Key_withLargeFont_Z234A7F09(key) {
    return new Key$1(key.Label, key.Variant, key.IsWide, true, key.Column, key.IsEnabled, key.Msg, key.LongPressMsg);
}

export function Key_withIcon(icon, key) {
    let matchValue;
    return new Key$1((matchValue = key.Label, (matchValue.tag === 1) ? (new ButtonLabel(1, [icon])) : ((matchValue.tag === 2) ? (new ButtonLabel(2, [icon, matchValue.fields[1]])) : (new ButtonLabel(2, [icon, matchValue.fields[0]])))), key.Variant, key.IsWide, key.IsLarge, key.Column, key.IsEnabled, key.Msg, key.LongPressMsg);
}

export function Key_confirm(text, msg) {
    return Key_Create_Z39EE07B2(text, msg, undefined, ButtonIcon_get_check(), true, undefined, undefined, "confirm");
}

export function Key_ok_1505(msg) {
    return Key_confirm("OK", msg);
}

export function Key_next_1505(msg) {
    return Key_confirm("Nächste Aufgabe", msg);
}

export function Key_clear_3CEEDAAD(inputMsg) {
    return Key_Create_Z39EE07B2("", inputMsg(new InputMsg(2, [false])), some(inputMsg(new InputMsg(2, [true]))), ButtonIcon_get_clear(), undefined, undefined, undefined, "destructive", true);
}

export function Key_comma_3CEEDAAD(inputMsg) {
    return Key_Create_Z39EE07B2(",", inputMsg(new InputMsg(1, [])), undefined, undefined, undefined, undefined, undefined, undefined, true);
}

export function Key_digits(inputMsg, lowerLeftKey, lowerRightKey) {
    const toMsg = (i) => inputMsg(new InputMsg(0, [i]));
    return toList(delay(() => append(singleton(Key_Create_Z39EE07B2("7", toMsg(7), undefined, undefined, undefined, undefined, undefined, undefined, true)), delay(() => append(singleton(Key_Create_Z39EE07B2("8", toMsg(8), undefined, undefined, undefined, undefined, undefined, undefined, true)), delay(() => append(singleton(Key_Create_Z39EE07B2("9", toMsg(9), undefined, undefined, undefined, undefined, undefined, undefined, true)), delay(() => append(singleton(Key_Create_Z39EE07B2("4", toMsg(4), undefined, undefined, undefined, undefined, undefined, undefined, true)), delay(() => append(singleton(Key_Create_Z39EE07B2("5", toMsg(5), undefined, undefined, undefined, undefined, undefined, undefined, true)), delay(() => append(singleton(Key_Create_Z39EE07B2("6", toMsg(6), undefined, undefined, undefined, undefined, undefined, undefined, true)), delay(() => append(singleton(Key_Create_Z39EE07B2("1", toMsg(1), undefined, undefined, undefined, undefined, undefined, undefined, true)), delay(() => append(singleton(Key_Create_Z39EE07B2("2", toMsg(2), undefined, undefined, undefined, undefined, undefined, undefined, true)), delay(() => append(singleton(Key_Create_Z39EE07B2("3", toMsg(3), undefined, undefined, undefined, undefined, undefined, undefined, true)), delay(() => append((lowerLeftKey != null) ? [value_13(lowerLeftKey)] : empty(), delay(() => append(singleton(Key_Create_Z39EE07B2("0", toMsg(0), undefined, undefined, undefined, 1, undefined, undefined, true)), delay(() => ((lowerRightKey != null) ? [value_13(lowerRightKey)] : empty())))))))))))))))))))))))));
}

export const OnScreenKeyboard = (memo)(function OnScreenKeyboard(props) { return (($props) => {
    const keys = $props.keys;
    const dispatch = $props.dispatch;
    const columns = $props.columns;
    const haptic = useHaptic();
    const longPressTimer = useRef(undefined);
    const isLongPress = useRef(false);
    const clearTimer = () => {
        const matchValue = longPressTimer.current;
        if (matchValue == null) {
        }
        else {
            const timer = matchValue;
            window.clearTimeout(timer);
        }
    };
    const patternInput_2 = mapFold((column, key) => {
        let matchValue_3;
        let patternInput;
        const matchValue_1 = key.Column;
        let matchResult;
        if (matchValue_1 != null) {
            switch (matchValue_1) {
                case 0: {
                    matchResult = 0;
                    break;
                }
                case 1: {
                    matchResult = 1;
                    break;
                }
                case 2: {
                    matchResult = 2;
                    break;
                }
                case 3: {
                    matchResult = 3;
                    break;
                }
                default:
                    matchResult = 4;
            }
        }
        else {
            matchResult = 4;
        }
        switch (matchResult) {
            case 0: {
                patternInput = [0, "col-start-1"];
                break;
            }
            case 1: {
                patternInput = [1, "col-start-2"];
                break;
            }
            case 2: {
                patternInput = [2, "col-start-3"];
                break;
            }
            case 3: {
                patternInput = [3, "col-start-4"];
                break;
            }
            default:
                patternInput = [column, undefined];
        }
        const column_1 = patternInput[0] | 0;
        const nextColumn = (key.IsWide ? 0 : ((column_1 + 1) % columns)) | 0;
        const classes = join(" ", choose((x) => x, ofArray([patternInput[1], (matchValue_3 = ((columns - column_1) | 0), key.IsWide ? ((matchValue_3 === 2) ? "col-span-2" : ((matchValue_3 === 3) ? "col-span-3" : ((matchValue_3 === 4) ? "col-span-4" : undefined))) : undefined), ""])));
        let patternInput_1;
        const matchValue_5 = key.Label;
        patternInput_1 = ((matchValue_5.tag === 1) ? [matchValue_5.fields[0], ""] : ((matchValue_5.tag === 2) ? [matchValue_5.fields[0], matchValue_5.fields[1]] : [undefined, matchValue_5.fields[0]]));
        const icon_2 = patternInput_1[0];
        return [                    <Button
                        key={key.Label}
                        className={classes}
                        variant={key.Variant}
                        size="xl"
                        disabled={!key.IsEnabled}
                        onTouchStart={(e_2) => {
            clearTimer();
            const timer_1 = window.setTimeout(() => {
                (() => {
                    clearTimer();
                    if (key.LongPressMsg != null) {
                        isLongPress.current = true;
                        dispatch(value_13(key.LongPressMsg));
                    }
                })();
            }, 500);
            longPressTimer.current = timer_1;
        }}
                        onTouchEnd={(e_3) => {
            clearTimer();
            isLongPress.current = false;
        }}
                        onClick={(e) => {
            e.preventDefault();
            if (!isLongPress.current) {
                dispatch(key.Msg);
                haptic.triggerHaptic();
            }
        }}>
                        <span className={concat(key.IsLarge ? "text-3xl" : "text-lg", ..." flex items-center justify-center gap-2")}>
            {(icon_2 != null) ? (<i className={value_13(icon_2)} />) : (null)}
            {patternInput_1[1]}
        </span>
                    </Button>
                , nextColumn];
    }, 0, keys);
    return <div className={concat("grid dark bg-background ", (columns === 1) ? "grid-cols-1" : ((columns === 2) ? "grid-cols-2" : ((columns === 3) ? "grid-cols-3" : ((columns === 4) ? "grid-cols-4" : (() => {
            throw new Exception("Unsupported number of columns");
        })()))), ..." gap-2 fixed bottom-0 left-0 right-0 p-2 pb-6 shadow-(--shadow-up)")}>
        {patternInput_2[0]}
    </div>;
})(props); }, function equalsButFunctions(x, y) {
    if (x === y) {
        return true;
    }
    else if ((typeof x === 'object' && !x[Symbol.iterator]) && !(y == null)) {
        const keys = Object.keys(x);
        const length = keys.length | 0;
        let i = 0;
        let result = true;
        while ((i < length) && result) {
            const key = keys[i];
            i = ((i + 1) | 0);
            const xValue = x[key];
            result = ((typeof xValue === 'function') ? true : equals(xValue, y[key]));
        }
        return result;
    }
    else {
        return equals(x, y);
    }
});

export function digitalKeyboard(dispatch, inputMsg, canClear, hasComma, additionalKeys) {
    const digitKeys = Key_digits(inputMsg, Key_withEnabled(canClear, Key_clear_3CEEDAAD(inputMsg)), hasComma ? Key_comma_3CEEDAAD(inputMsg) : undefined);
    return createElement(OnScreenKeyboard, {
        columns: 3,
        dispatch: dispatch,
        keys: append_1(additionalKeys, digitKeys),
    });
}

